import {useEffect} from 'react';

import {ELEMENT_CLASSNAME} from '../utils/consts';
import {WidgetSvg} from './types';

const useOffClick = (svgRootObj: WidgetSvg | undefined, onOffClick: () => void, exemptRefs?: Array<Element>) => {
	const isExempt = ({clientX, clientY}: {clientX: number; clientY: number}) => {
		if (!exemptRefs) {
			return false;
		}

		return exemptRefs.some((ref) => {
			const rect = ref.getBoundingClientRect();
			return rect.left <= clientX && rect.right >= clientX && rect.top <= clientY && rect.bottom >= clientY;
		});
	};

	const isOffClick = (event: MouseEvent) => {
		if (!svgRootObj) {
			return;
		}
		const elementsWithMarkers = svgRootObj.select(`g.${ELEMENT_CLASSNAME}`);
		return !elementsWithMarkers?.members.some((element) => element.node.contains(event.target));
	};

	const handleOffClick = (event: MouseEvent) => {
		if (svgRootObj) {
			if (isOffClick(event) && !isExempt(event)) {
				onOffClick();
			}
		}
	};

	useEffect(() => {
		document.addEventListener('mousedown', handleOffClick, {
			passive: true
		});
		return () => {
			document.removeEventListener('mousedown', handleOffClick);
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [svgRootObj]);
};

export default useOffClick;
